import { Component } from '@angular/core';
import { soundpostSyncLogEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Sync Logs') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostsynclog-form',
    templateUrl: './soundpostsynclog.form.component.html'
})
export class soundpostSyncLogFormComponent extends BaseFormComponent {
    public record!: soundpostSyncLogEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

